import { Component, ViewChild } from '@angular/core';
import { ModalController, ActionSheetController, NavController, Tabs } from 'ionic-angular';

import { AbstractPage } from '../_com/abstract-page';
import { ReserveListPage } from '../reserve/list/reserve-list';
import { ReserveEditPage } from '../reserve/edit/reserve-edit';
import { FamilyListPage } from '../family/list/family-list';
import { PhotoConfirmPage } from '../_com/photo-confirm/photo-confirm';
import { PhotoRequestListPage } from '../photo-request/list/photo-request-list';
import { StaffListPage } from '../staff/list/staff-list';
// import { FeedPage } from '../feed/feed';
import { ProfilePage } from '../profile/profile';
import { SignatureDetailPage } from '../signature/detail/signature-detail';
import { PasswordResetPage } from '../password-reset/password-reset';
import { SmsFollowPage } from '../sms-follow/sms-follow';
import { LoginPage } from '../login/login';
// import { SettingPage } from '../setting/setting';
import { ReserveRequestPage } from '../reserve-request/reserve-request';
import { BadgeStore } from '../../stores/badge-store';
import { Subscription } from 'rxjs/Subscription';
import { ReserveAction } from '../../actions/reserve.action';
import { StaffAction } from '../../actions/staff.action';
import { CompReserveListState } from '../../states/comp-reserve-list-state';
import { HttpReserveProvider } from '../../providers/http-reserve';
import Utils from '../../_com/utils';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage extends AbstractPage{

  reserveListPage = ReserveListPage;
  reserveEditPage = ReserveEditPage;
  familyListPage = FamilyListPage;
  photoConfirmPage = PhotoConfirmPage;
  photoRequestListPage = PhotoRequestListPage;
  reserveRequestPage = ReserveRequestPage;

  onChangeBadge : Subscription;

  badge = {};
  onChangeDate = null;
  onSaveReserve = null;
  reserveList: any;
  isSignatureTextExists: Boolean;

  @ViewChild('myTabs') tabRef: Tabs;

  constructor(
  	private modalController:ModalController,
    private actionSheetController:ActionSheetController,
    private navController:NavController,
    private reserveAction:ReserveAction,
    private badgeStore:BadgeStore,
    private compReserveListState:CompReserveListState,
    private httpReserveProvider:HttpReserveProvider,
    public staffAction:StaffAction,
  	) {
    super();
    this.refresh();

    /**
     * 表示日付切り替えイベント
     */
    this.onChangeDate = this.compReserveListState.onChangeDate.subscribe((data)=>{
      this.refresh();
    });

    /**
     * 予約情報更新イベント
     */
    this.onSaveReserve = this.httpReserveProvider.onSaveReserve.subscribe((data)=>{
      this.refresh();
    });

    /**
     * バッジ変更イベント
     */
    this.onChangeBadge = this.badgeStore.onChangeBadge.subscribe(data=>{
      this.badge[data["key"]] = data["count"];
    })
    this.refreshBadge();
  }

  ionViewDidLoad(){

    //最新バッジ情報取得
    setInterval(() => {
      this.refreshBadge(false);
    }, 60000)
  }

  /**
   * WebSocketが完成するまでの暫定バッジ処理
   */
  refreshBadge(needLoading:boolean = true){
    this.reserveAction.getListPhotoRequest().subscribe(data=>{
      this.badgeStore.setBadgePhotoRequest(data.data.length);
    });
    this.reserveAction.getListReserveRequest().subscribe(data => {
      this.badgeStore.setBadgeReserveRequest(data.data.length);
    });
  }

  /**
   * 一覧データ取得
   */
  refresh(){
    this.reserveAction.getList({date:this.compReserveListState.date, isValidOnly:false}).subscribe((res)=>{
      this.reserveList = res.data;
    });
  }

  /**
   * 新規予約
   */
  createReserve(){

		let modal = this.modalController.create(ReserveEditPage, {}, {enableBackdropDismiss:false});
		modal.present();
  }

  /**
   * 写真リクエストページの起動
   */
  photoRequest(){
    // this.events.publish("tabs:photoRequest");
  }

  showMoreMenu(){

    let actionSheet = this.actionSheetController.create({
     title: 'その他',
     buttons: [
       {
         text: '新規予約',
         handler: () => {
           this.createReserve();
         }
       },
       {
         text: 'SMS未達フォロー',
         handler: () => {
           this.navController.push(SmsFollowPage);
         }
       },
       {
         text: '保護者パスワード初期化',
         handler: () => {
           this.navController.push(PasswordResetPage);
         }
       },
       {
         text: 'スタッフ管理',
         handler: () => {
           this.navController.push(StaffListPage);
         }
       },
       {
         text: 'マイプロフィール',
         handler: () => {
           this.navController.push(ProfilePage);
         }
       },
       {
        text: '同意書文言変更',
        handler: () => {
          this.navController.push(SignatureDetailPage);
        }
      },
      {
        text: 'CSV出力',
        handler: () => {
          this.outputCsv();
        }
      },
       // {
       //   text: '設定',
       //   handler: () => {
       //     this.navController.push(SettingPage);
       //   }
       // },
       {
         text: 'ログアウト',
         handler: () => {
           this.setRoot(this.navController, LoginPage, false);
         }
       },
       {
         text: 'キャンセル',
         role: 'cancel',
         handler: () => {
         }
       }
     ]
    });
    actionSheet.present();
  }

  /**
   * subscription破棄
   */
  ngOnDestroy(){
    this.onChangeBadge.unsubscribe();
    this.onChangeDate.unsubscribe();
    this.onSaveReserve.unsubscribe();
  }

  // csv出力
  async outputCsv() {
    // 指定した日付のデータを出力する
    if (this.reserveList.length === 0) {
      alert('予約が見つからないため、CSVで出力できませんでした。');
      return;
    };

    const reserveList = this.reserveList; // 予約リスト
    const FileTitle = Utils.date.format(Utils.date.getDateFromHyphen(reserveList[0].Reserve.datetime.date), "yyyy_MM_dd");// csvファイルのタイトルを生成
    const outputLine = [];
    // csvファイルのヘッダーを作成（不要？かどうか確認する）
    outputLine.push(["予約日付","料金明細", "名前", "歳", "ヶ月", "当日予約", "開始時間", "終了時間", "ランチ", "おやつ", "夕食", "ぴよか", "兄弟2人目","入浴", "イベント", "ベジ・フル", "授乳", "アレルギー","未食","おかゆ","おかず"]);

    // CSVの形式
    reserveList.forEach((data => {
      data = Object.assign({}, data);
      data.Reserve.children.forEach((child => {
        let reserveDate = Utils.date.format(Utils.date.getDateFromHyphen(data.Reserve.datetime.date), "yyyy年M月d日(EEEE)");
        let okayu = '';
        let isOkayuExists = false;
        if (child.data.Child.rinyusyoku_okayu) {
          isOkayuExists = true;
          switch (child.data.Child.rinyusyoku_okayu) {
            case "F":
              okayu = "普通のご飯";
            case "N":
              okayu = "軟飯";
            case "5":
              okayu = "５倍がゆ";
            case "7":
              okayu = "７倍がゆ";
            case "10":
              okayu = "１０倍がゆ";
          }
        }

        let yasai = '';
        let isYasaiExists = false;
        if (child.data.Child.keijyo_yasai) {
          isYasaiExists = true;
          switch (child.data.Child.keijyo_yasai) {
            case "1":
              yasai = "幼児食(1⼝⼤)";
            case "2":
              yasai = "幼児⾷(刻み)";
            case "3":
              yasai = "後期 (1cm角)";
            case "4":
              yasai = "中期（みじん切り）";
            case "5":
              yasai = "初期（すりおろし）";
          }
        }

        // おかず
        outputLine.push([
          `${reserveDate}`, // 予約日付
          `${data.Reserve.type ? data.Reserve.type : ""}`, // 料金明細（予約時の「区分」から取得）
          `${child.data.Child.name ? child.data.Child.name : ""}`, // 子供の名前
          `${child.childOfAge[0] ? child.childOfAge[0] : ""}`, // 年齢
          `${child.childOfAge[1] ? child.childOfAge[1] : ""}`, // 月齢
          `""`, // 当日予約 or not
          `${data.Reserve.datetime.time[0] ? data.Reserve.datetime.time[0]: ""}`, // 開始時間
          `${data.Reserve.datetime.time[1] ? data.Reserve.datetime.time[1]: ""}`, // 終了時間
          `"0"`, // ランチ（あり：１,なし：０）
          `"0"`, // おやつ（あり：１,なし：０）
          `"0"`, // 夕食（あり：１,なし：０）
          `"0"`, // ぴよか（あり：１,なし：０）
          `"0"`, // 兄弟2人目（あり：１,なし：０）
          `"0"`, // 入浴（あり：１,なし：０）
          `"0"`, // イベント（1:教室,2:プール,3:園内プール）
          `"0"`, // ベジフル（回数）
          `"0"`, // 授乳（回数）
          `${child.data.Child.allergy_text ? child.data.Child.allergy_text : "×"}`, // アレルギー
          `""`, // 未食
          `${isOkayuExists ? okayu : ""}`, // おかゆ
          `${isYasaiExists ? yasai : ""}`, // おかず
        ]);
      }));
    }))

    // csvテキストに整形
    const lf = '\n';
    let outputCsvString = '';
    outputLine.forEach(oneline => {
      outputCsvString += oneline.join(',') + lf;
    });
    // Excelで扱えるよう、BOM有りUTF-8として出力
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const blob = new Blob([bom, outputCsvString], {type: 'text/csv'});
    // ダウンロード
    const url = window.URL.createObjectURL(blob);
    // ファイル名どうする？
    const fileName = FileTitle + '_' + "請求書情報" + '.csv';
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts